import React from 'react';

const CaseViewDetails = ({ caseData }) => (
  <div className='border border-StrokeColor rounded-5 p-4'>
    <div className='grid xl:grid-cols-3 md:grid-cols-2 gap-4'>
      <div className=''>
        <p className='summary-label'>Case Number</p>
        <p className='summary-value xl:!w-[140px] !break-words'>{caseData?.caseNumber || ''}</p>
      </div>
      <div className=''>
        <p className='summary-label'>Case Title</p>
        <p className='summary-value xl:!w-[140px] !break-words'>{caseData?.caseTitle || ''}</p>
      </div>
      <div className=''>
        <p className='summary-label'>Case State</p>
        <p className='summary-value xl:!w-[140px] !break-words'>{caseData?.state || ''}</p>
      </div>
      {caseData?.state?.toLowerCase() === "reopened" && (
        <div className=''>
          <p className='summary-label'>Customer Remarks</p>
          <p className='summary-value xl:!w-[140px] !break-words'>{caseData?.remarks || ''}</p>
        </div>)}
      <div className=''>
        <p className='summary-label'>Module</p>
        <p className='summary-value xl:!w-[140px] !break-words'>{caseData?.appName || ''}</p>
      </div>
    </div>
</div>
);

export default CaseViewDetails;
